import { render, staticRenderFns } from "./ShowSkusExTable.vue?vue&type=template&id=3b5da4a3"
import script from "./ShowSkusExTable.vue?vue&type=script&lang=js"
export * from "./ShowSkusExTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports